import * as DashboardActions from '../actions/dashboard';
import DashboardService from '@/services/dashboard.service';

import * as moment from 'moment';

const state = {
    loaded: false,
    loading: true,
    error: false,
    period: 4,
    start: null,
    end: null,
    points: {
        initial: 0,
        total: 0,
        total_active: 0,
        sales_active: 0,
        sales: 0,
        trainings: 0,
        redemptions: 0,
    },
    users: {
        preregistered: 0,
        active: 0,
        inactive: 0,
        ex_client: 0,
        new: 0,
        new_of_the_week: 0,
    },
    finishedTrainings: 0,
    campaignsCount: 0,
    redemptions_info: {
        card_value_sleepy: 0,
        card_qnt_sleepy: 0,
        card_value_pending: 0,
        card_qnt_pending: 0,
        card_value_finished: 0,
        card_qnt_finished: 0,
        card_value_total: 0,
        card_qnt_total: 0,
        card_tax: 0,
        mapipay_value_sleepy: 0,
        mapipay_qnt_sleepy: 0,
        mapipay_value_pending: 0,
        mapipay_qnt_pending: 0,
        mapipay_value_finished: 0,
        mapipay_value_total: 0,
        mapipay_qnt_total: 0,
        britz_value: 0,
        britz_qnt: 0,
        chargebacks: 0,
    },
    redemptions: [],
    balance: {
        advance: 0,
        total_redemptions: 0,
        total_taxes: 0,
        finished: 0,
        sleepy: 0,
        initial_balance: 0,
        current_balance: 0,
    },
};

const getters = {};

const actions = {
    [DashboardActions.LOAD]: ({ commit }, { id, start, end }) => {
        return new Promise((resolve, reject) => {
            commit(DashboardActions.LOAD, id);

            const startDate = moment(start).format('YYYY-MM-DD');
            const endDate = moment(end).format('YYYY-MM-DD');

            const currentDate = moment(new Date()).format('YYYY-MM-DD');
            const lastWeek = moment(new Date())
                .subtract(7, 'day')
                .format('YYYY-MM-DD');

            DashboardService.load(startDate, endDate, currentDate, lastWeek)
                .then(({ data }) => {
                    commit(DashboardActions.LOAD_SUCCESS, {
                        data,
                        start,
                        end,
                    });
                    resolve();
                })
                .catch(() => {
                    commit(DashboardActions.LOAD_ERROR);
                    reject();
                });
        });
    },
};

const mutations = {
    [DashboardActions.LOAD]: (state, periodId) => {
        state.loaded = false;
        state.loading = true;
        state.error = false;
        state.period = periodId;
    },
    [DashboardActions.LOAD_SUCCESS]: (state, { data, start, end }) => {
        const {
            users,
            points,
            pointsRedeem,
            finishedTrainings,
            campaignsCount,
            redemptions,
            redemptions_info,
            balance,
        } = data;

        state.loading = false;
        state.loaded = true;
        state.start = start;
        state.end = end;
        state.users = users;
        state.points = points;
        state.pointsRedeem = pointsRedeem;
        state.finishedTrainings = finishedTrainings;
        state.campaignsCount = campaignsCount;
        state.redemptions_info = redemptions_info;
        state.redemptions = redemptions;
        state.balance = balance;
    },
    [DashboardActions.LOAD_ERROR]: (state) => {
        state.loaded = false;
        state.loading = false;
        state.error = true;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};